// extracted by mini-css-extract-plugin
export default {"root":"AlertTemplate-module-root","error":"AlertTemplate-module-error","info":"AlertTemplate-module-info","success":"AlertTemplate-module-success"};